import DataTable from "react-data-table-component";
import customStyles from "../../../data/dataTableStyle";
import { dataFormatNumberDecimal } from "../../../data/dataFormatNumberDecimal";

// Eliminadas las interfaces IndicatorRow y TableIndicatorsProps

const TableIndicators = ({ reportData }) => {
    if (!reportData) return <p>No hay datos para mostrar</p>;
    
    const rows = reportData;

    const columns = [
        {
            name: "Indicador",
            selector: (row) => row.indicador,
            wrap: true,
        },
        {
            name: "Resultado",
            cell: (row) => {
                const parts = row.resultado.toString().split(" ");
                return (
                    <div>
                        {dataFormatNumberDecimal(parts[0])} {parts[1] || ""}
                    </div>
                );
            },
            wrap: true,
        },
        {
            name: "Términos",
            cell: (row) => (
                <div className="flex flex-wrap gap-1">
                    {row.terminos.split(" | ").map((term, idx) => (
                        !term.startsWith("indicator_unit:") && (
                            <span
                                key={idx}
                                className="bg-slate-100 border hover:bg-slate-50 border-slate-300 hover:border-slate-400 text-slate-500 hover:font-semibold text-sm px-2 py-1 rounded-full"
                            >
                                {term.split(": ")[0].replace(/_/g, " ")}
                                {`: ${dataFormatNumberDecimal(term.split(": ")[1])}`}
                            </span>
                        )
                    ))}
                </div>
            ),
            width: "550px",
            grow: 3,
        },
    ];

    return (
        <div className="overflow-hidden rounded-lg">
            <DataTable
                title="Indicadores"
                noDataComponent="No hay registros para mostrar"
                columns={columns}
                data={rows}
                responsive
                dense
                highlightOnHover
                striped
                customStyles={customStyles}
            />
        </div>
    );
};

export default TableIndicators;